'use client'

import { createContext, useContext, ReactNode } from 'react'
import { sendGAEvent } from '@next/third-parties/google'

interface GoogleAnalyticsContextType {
    addToCartGA: (data: GoogleAnalytics.AddToCart) => void
    beginCheckoutGA: (data: GoogleAnalytics.BeginCheckout) => void
    purchaseGA: (data: GoogleAnalytics.Purchase) => void
    selectPromotionGA: (data: GoogleAnalytics.SelectPromotion) => void
    viewCartGA: (data: GoogleAnalytics.ViewCart) => void
    viewItemGA: (data: GoogleAnalytics.ViewItem) => void
}

const GoogleAnalyticsContext = createContext<GoogleAnalyticsContextType | undefined>(undefined)

export const GoogleAnalyticsProvider = ({ children }: { children: ReactNode }) => {

    const addToCartGA = (data: GoogleAnalytics.AddToCart) => {
        sendGAEvent('event', 'add_to_cart', { value: data })
    }

    const beginCheckoutGA = (data: GoogleAnalytics.BeginCheckout) => {
        sendGAEvent('event', 'begin_checkout', { value: data })
    }

    const purchaseGA = (data: GoogleAnalytics.Purchase) => {
        sendGAEvent('event', 'purchase', { value: data })
    }

    const selectPromotionGA = (data: GoogleAnalytics.SelectPromotion) => {
        sendGAEvent('event', 'select_promotion', { value: data })
    }

    const viewCartGA = (data: GoogleAnalytics.ViewCart) => {
        sendGAEvent('event', 'view_cart', { value: data })
    }

    const viewItemGA = (data: GoogleAnalytics.ViewItem) => {
        sendGAEvent('event', 'view_item', { value: data })
    }

    return (
        <GoogleAnalyticsContext.Provider value={{ addToCartGA, beginCheckoutGA, purchaseGA, selectPromotionGA, viewCartGA, viewItemGA }}>
            {children}
        </GoogleAnalyticsContext.Provider>
    )
}

export const useGoogleAnalytics = (): GoogleAnalyticsContextType => {
    const context = useContext(GoogleAnalyticsContext)
    if (!context) {
        throw new Error('useGoogleAnalytics deve ser usado dentro de um GoogleAnalyticsProvider')
    }
    return context
}
